/**
 * A product-fetch payload as collapsed, per-section JSON. Takes `unknown` and
 * casts once here: the core types the payload as a recursive `JsonObject`, and
 * tsc reports "excessively deep" the moment a component reads through it.
 */
export function PayloadSections({ payload }: { payload: unknown }) {
  return (
    <>
      {Object.entries((payload ?? {}) as Record<string, unknown>).map(([key, value]) => (
        <details key={key} className="rounded-md border px-3 py-2">
          <summary className="cursor-pointer text-sm font-medium">{key}</summary>
          <pre className="mt-2 max-h-105 overflow-auto rounded bg-muted/50 p-3 text-xs">
            {JSON.stringify(value, null, 2)}
          </pre>
        </details>
      ))}
    </>
  );
}
